import { reviewList, principleList, timeline } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading eyebrow="关于我们" title="把热点讲清楚，是吃瓜17 的初心" sub="我们是一支专注热点聚合与内容梳理的小团队，愿做大家在喧嚣网络里的一盏理性小灯。" align="center" />

        <div className="mt-10 grid gap-8 lg:grid-cols-2">
          {/* 品牌介绍 + 原则 */}
          <div className="flex flex-col gap-6">
            <div className="rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
              <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-accent-900">
                <i className="ri-seedling-line text-accent-600"></i>
                品牌与定位
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                吃瓜17 诞生于这样一个朴素的想法：与其在碎片化信息里反复横跳、被情绪带着走，不如有一处地方能把一个热点讲明白。
                我们以榜单与盘点为载体，把散落的热议大瓜与焦点话题梳理出清晰的时间线，标注来源、还原走向，让你花最少的时间掌握最多有效信息。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                从每日热度播报，到分类专区、深度盘点，我们始终坚持中立呈现、尊重事实。热闹是网络给的，清醒是自己选的——这就是吃瓜17 想陪你一起做到的事。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {principleList.map((p) => (
                  <span key={p} className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
                    <i className="ri-check-double-line text-accent-600"></i>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* 发展理念时间线 */}
          <div className="rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
            <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-primary-700">
              <i className="ri-flag-2-line text-primary-600"></i>
              发展足迹
            </h3>
            <div className="relative mt-6 space-y-6 border-l-2 border-accent-200 pl-6">
              {timeline.map((t, i) => (
                <div key={t.year} className="relative">
                  <span className={`absolute -left-[2.05rem] flex h-5 w-5 items-center justify-center rounded-full ${i === timeline.length - 1 ? "bg-primary-500" : "bg-accent-500"}`}>
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
                  </span>
                  <p className="text-xs font-bold tracking-wide text-accent-700">{t.year}</p>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-800">{t.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-10 rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
          <div className="flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-chat-heart-line text-primary-600"></i>
              大家怎么评价吃瓜17
            </h3>
            <div className="flex items-center gap-1 text-secondary-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-primary-500"></i>
              ))}
              <span className="ml-1 text-xs text-foreground-600 whitespace-nowrap">综合好评 4.9 / 5</span>
            </div>
          </div>
          <div className="mt-5 grid gap-4 md:grid-cols-3">
            {reviewList.map((r) => (
              <figure key={r.name} className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5">
                <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-800">{r.quote}</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-background-50">
                    {r.name.charAt(0)}
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-foreground-950">{r.name}</span>
                    <span className="block text-xs text-foreground-600">{r.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}